// wp-icons — Navigation & Arrows (16)
import { createWpIcon } from './createIcon.js';

export const ArrowLeft = createWpIcon('ArrowLeft', [
  ['path', { d: 'M19 12H5', key: 'a' }],
  ['path', { d: 'm12 19-7-7 7-7', key: 'b' }],
]);
export const ArrowRight = createWpIcon('ArrowRight', [
  ['path', { d: 'M5 12h14', key: 'a' }],
  ['path', { d: 'm12 5 7 7-7 7', key: 'b' }],
]);
export const ArrowUpRight = createWpIcon('ArrowUpRight', [
  ['path', { d: 'M7 7h10v10', key: 'a' }],
  ['path', { d: 'M7 17 17 7', key: 'b' }],
]);
export const ArrowDownLeft = createWpIcon('ArrowDownLeft', [
  ['path', { d: 'M17 7 7 17', key: 'a' }],
  ['path', { d: 'M17 17H7V7', key: 'b' }],
]);
export const ArrowDownCircle = createWpIcon('ArrowDownCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'M8 12l4 4 4-4', key: 'b' }],
  ['path', { d: 'M12 8v8', key: 'c' }],
]);
export const ArrowRightLeft = createWpIcon('ArrowRightLeft', [
  ['path', { d: 'M8 3 4 7l4 4', key: 'a' }],
  ['path', { d: 'M4 7h16', key: 'b' }],
  ['path', { d: 'm16 21 4-4-4-4', key: 'c' }],
  ['path', { d: 'M20 17H4', key: 'd' }],
]);
export const ArrowUpDown = createWpIcon('ArrowUpDown', [
  ['path', { d: 'm21 16-4 4-4-4', key: 'a' }],
  ['path', { d: 'M17 20V4', key: 'b' }],
  ['path', { d: 'm3 8 4-4 4 4', key: 'c' }],
  ['path', { d: 'M7 4v16', key: 'd' }],
]);
export const ArrowUpWideNarrow = createWpIcon('ArrowUpWideNarrow', [
  ['path', { d: 'm3 8 4-4 4 4', key: 'a' }],
  ['path', { d: 'M7 4v16', key: 'b' }],
  ['path', { d: 'M11 12h10', key: 'c' }],
  ['path', { d: 'M11 16h7', key: 'd' }],
  ['path', { d: 'M11 20h4', key: 'e' }],
]);
export const ArrowDownWideNarrow = createWpIcon('ArrowDownWideNarrow', [
  ['path', { d: 'm3 16 4 4 4-4', key: 'a' }],
  ['path', { d: 'M7 20V4', key: 'b' }],
  ['path', { d: 'M11 4h10', key: 'c' }],
  ['path', { d: 'M11 8h7', key: 'd' }],
  ['path', { d: 'M11 12h4', key: 'e' }],
]);
export const ChevronLeft = createWpIcon('ChevronLeft', [['path', { d: 'm15 18-6-6 6-6', key: 'a' }]]);
export const ChevronRight = createWpIcon('ChevronRight', [['path', { d: 'm9 18 6-6-6-6', key: 'a' }]]);
export const ChevronUp = createWpIcon('ChevronUp', [['path', { d: 'm18 15-6-6-6 6', key: 'a' }]]);
export const ChevronDown = createWpIcon('ChevronDown', [['path', { d: 'm6 9 6 6 6-6', key: 'a' }]]);
export const Undo2 = createWpIcon('Undo2', [
  ['path', { d: 'M9 14 4 9l5-5', key: 'a' }],
  ['path', { d: 'M4 9h10.5a5.5 5.5 0 0 1 0 11H11', key: 'b' }],
]);
export const RotateCcw = createWpIcon('RotateCcw', [
  ['path', { d: 'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', key: 'a' }],
  ['path', { d: 'M3 3v5h5', key: 'b' }],
]);
export const Repeat = createWpIcon('Repeat', [
  ['path', { d: 'm17 2 4 4-4 4', key: 'a' }],
  ['path', { d: 'M3 11v-1a4 4 0 0 1 4-4h14', key: 'b' }],
  ['path', { d: 'm7 22-4-4 4-4', key: 'c' }],
  ['path', { d: 'M21 13v1a4 4 0 0 1-4 4H3', key: 'd' }],
]);
export const RefreshCw = createWpIcon('RefreshCw', [
  ['path', { d: 'M3 12a9 9 0 0 1 15.5-6.36L21 8', key: 'a' }],
  ['path', { d: 'M21 3v5h-5', key: 'b' }],
  ['path', { d: 'M21 12a9 9 0 0 1-15.5 6.36L3 16', key: 'c' }],
  ['path', { d: 'M3 21v-5h5', key: 'd' }],
]);
